<div style="position: absolute; width: 100%; height: 100%; overflow: hidden; scroll-behavior: smooth;">
    <div [@_colorPickerState]="colorPickerType" style="position: absolute; width: 100%; height: 100%;">
        <hsb-color-picker #hsb style="position: absolute; top: 0px; width: 100%; height: 100%;"></hsb-color-picker>
        <rgb-color-picker #rgb style="position: absolute; top: 100%; width: 100%; height: 100%;"></rgb-color-picker>
    </div>
</div>